import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BCServiceOrder } from "../../Interfaces/BCServiceOrder";
import { Service } from "../../Interfaces/Service";
import { DataService } from "../../Services/DataService";
import { Card, Skeleton, Button, Row, Col, List, Divider, Form, DatePicker, Switch, notification, Tag, Select, Input } from "antd";
import PageHeaderAstena from "../../Components/PageHeaderAstena";
import Title from "antd/es/typography/Title";
import { BCTimeRegistration } from "../../Interfaces/BCTimeRegistration";
import dayjs, { Dayjs } from "dayjs";
import locale from 'antd/es/date-picker/locale/nl_BE';
import TimePicker from "react-time-picker";
import { CloseOutlined, CalendarOutlined, ClockCircleOutlined, UserOutlined, CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../Redux/hooks";
import { BCResource } from "../../Interfaces/BCResource";
import SignatureCanvas from "react-signature-canvas";
import { BCServiceItemLine } from "../../Interfaces/BCServiceItemLine";

type OrderParams = {
    orderId: string;
}

const CreateTimeRegistration = () => {

    let navigate = useNavigate();
    let params = useParams<OrderParams>();
    const user = useAppSelector(state => state.user);

    const [form] = Form.useForm();

    const [order, setOrder] = useState<Service<BCServiceOrder>>({ status: "loading" });
    const [regs, setRegs] = useState<Service<BCTimeRegistration[]>>({ status: "loading" });
    const [resources, setResources] = useState<Service<BCResource[]>>({ status: "loading" });
    const [itemLines, setItemLines] = useState<Service<BCServiceItemLine[]>>({ status: "loading" });
    const [loading, setLoading] = useState(false);
    const [logsLoading, setLogsLoading] = useState(false);

    const [signer, setSigner] = useState<string>("");
    const [signDate, setSignDate] = useState<dayjs.Dayjs>(dayjs());
    const signatureRef = React.useRef<SignatureCanvas>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const resizeCanvas = () => {
            if (signatureRef.current && containerRef.current && signatureRef.current._canvas) {
                const width = containerRef.current.offsetWidth;
                signatureRef.current.clear(); // Optional: clear on resize
                signatureRef.current.off();   // Turn off drawing temporarily
                signatureRef.current._canvas.width = width;
                signatureRef.current._canvas.height = 200; // Set desired height
                signatureRef.current.on();    // Turn drawing back on
            }
        };

        resizeCanvas();
        window.addEventListener("resize", resizeCanvas);
        return () => window.removeEventListener("resize", resizeCanvas);
    }, []);
    React.useEffect(() => {
        getOrder();
        getLogs();
        getResources();
        getServiceItemLines();
    }, []);
    function getOrder() {
        if (params.orderId) {
            DataService.getServiceOrder(params.orderId).then(res => {
                setOrder(res);
            }).catch(err => {
                setOrder({ status: "error", error: err })
            })
        }
    }
    function getLogs() {
        if (params.orderId) {
            setLogsLoading(true);
            DataService.getTimeRegistrationsForOrder(params.orderId).then(res => {
                setRegs(res);
            }).catch(err => {
                setRegs({ status: "error", error: err })
            }).finally(() => {
                setLogsLoading(false);
            });
        }
    }
    function getResources() {
        DataService.getResources().then(res => {
            setResources(res);
        }).catch(err => {
            setResources({ status: "error", error: err })
        })
    }

    function getServiceItemLines() {
        if (params.orderId) {
            DataService.getLinesForOrder(params.orderId!).then(res => {
                setItemLines(res);
            }).catch(err => {
                setItemLines({ status: "error", error: err })
            }).finally(() => { })
        }
    }

    function onFinish(values: any) {
        //form.validateFields()
        //    .then((values) => {
        //console.log("values", values);

        if (params.orderId) {
            if (values.start >= values.stop) {
                notification.error({
                    message: "Einduur moet groter zijn dan startuur."
                });
                return;
            }

            let base64 = "";
            if (signatureRef && signatureRef.current) {
                /*if (signatureRef.current.isEmpty()) {
                    notification.error({
                        message: "Signature required."
                    });
                    return;
                }*/
                if (!signatureRef.current.isEmpty())
                    base64 = signatureRef.current.toDataURL();
            }

            setLoading(true);
            DataService.addTimeRegistration({
                orderNo: params.orderId,
                resourceNo: values.resourceNo,
                isFinished: values.finished,
                startingDateTime: dayjs(`${values.date.format("YYYY-MM-DD")} ${values.start}`).toISOString(),
                endingDateTime: dayjs(`${values.date.format("YYYY-MM-DD")} ${values.stop}`).toISOString(),
                breakTime: dayjs(`${values.date.format("YYYY-MM-DD")} ${values.break}`).toISOString(),
                signerName: base64 ? signer : "",
                signDate: signDate.format("YYYY-MM-DD"),
                signature64: base64
            }).then(res => {
                form.resetFields();
                notification.success({
                    message: "Tijdsregistratie werd succesvol toegevoegd."
                });
                if (signatureRef.current) {
                    signatureRef.current.clear();
                    setSignDate(dayjs());
                    setSigner("");
                }
                getLogs();
                if (values.finished) {
                    getOrder();
                    getServiceItemLines();
                }
            }).catch(err => {
                notification.error({
                    description: err.error.response.data.Message,
                    message: "Opslaan registratie mislukt.",
                    duration: 8
                })
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    return (
        <div>
            <Card style={{ marginBottom: 4 }} bodyStyle={{ padding: 16, margin: 0 }}>
                <PageHeaderAstena
                    //style={{ padding: "16px 16px 0px 16px" }}
                    title={
                        (order.status === "loaded" && itemLines.status === "loaded") ? (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "#959595" }}>
                                    {order.payload.description}
                                    {/*<Tag style={{ marginLeft: 4 }} color={order.payload.status === "Finished" ? "red" : "green"}>{order.payload.status}</Tag>*/}
                                    {itemLines.payload.length > 0 && (
                                        <Tag style={{ marginLeft: 4 }} color={"blue"}>{itemLines.payload[0].repairStatusCode}</Tag>
                                    )}
                                </span>
                                <Title style={{ margin: 0, color: "#69ACFD", verticalAlign: "middle" }} level={3}>{"Tijdsregistratie"}</Title>
                            </div>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Skeleton.Input active style={{ marginBottom: 4 }} />
                                <Skeleton.Input active style={{ minWidth: 350 }} />
                            </div>
                        )
                    }

                    onBack={() => navigate(-1)}
                />
            </Card>
            <Row gutter={[4, 4]}>
                <Col xl={8} lg={8} md={12} sm={24}>

                    <Card bodyStyle={{ padding: 16, margin: 0 }}>
                        <PageHeaderAstena
                            style={{ padding: 0, margin: 0, marginBottom: 16 }}
                            title={
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Historiek"}</span>
                            }

                        />
                        <div style={{ marginLeft: 8 }}>
                            {regs.status === "loaded" && (
                                <List
                                    pagination={{
                                        pageSize: 8
                                    }}
                                    loading={logsLoading}
                                    locale={{ emptyText: "Geen historiek" }}
                                    dataSource={regs.payload.sort((a, b) => b.startingDateTime.localeCompare(a.startingDateTime))}
                                    renderItem={(reg) => (
                                        <div>
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <div style={{
                                                    display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
                                                    backgroundColor: "#959595", color: "white", padding: "8px 16px"
                                                }}>
                                                    <span style={{ fontWeight: "bold" }}>{dayjs(reg.startingDateTime).format("DD/MM")}</span>
                                                    <span style={{ fontSize: 12 }}>{dayjs(reg.startingDateTime).format("YYYY")}</span>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: 16 }}>
                                                    <span style={{ color: "#959595" }}>{reg.serviceOrderNo}</span>
                                                    <span style={{ fontWeight: "bold" }}>{reg.serviceOrderDescription}</span>
                                                    <span style={{}}>{reg.resourceName}</span>
                                                    <span style={{ color: "#69ACFD" }}>{dayjs(reg.startingDateTime).format("HH:mm")} - {dayjs(reg.endingDateTime).format("HH:mm")}</span>
                                                </div>
                                            </div>
                                            <Divider />
                                        </div>
                                    )}
                                />
                            )}
                            {regs.status === "loading" && (
                                <List
                                    dataSource={Array.from(Array(3).keys())}
                                    renderItem={(log) => (
                                        <div>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                <Skeleton.Avatar shape="square" active size={"large"} />
                                                <div style={{ paddingLeft: 16 }}>
                                                    <Skeleton.Input active />
                                                </div>
                                            </div>
                                            <Divider />
                                        </div>
                                    )}
                                />
                            )}
                        </div>
                    </Card>
                </Col>
                <Col xl={8} lg={8} md={12} sm={24}>
                    <Card bodyStyle={{ padding: 16, margin: 0 }}>
                        <PageHeaderAstena
                            style={{ padding: 0, margin: 0, marginBottom: 16 }}
                            title={
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Nieuwe registratie"}</span>
                            }

                        />
                        <Form
                            labelCol={{ span: 3 }}
                            form={form}
                            layout="horizontal"
                            name="form_in_modal"
                            onFinish={onFinish}
                            requiredMark={false}
                            labelWrap
                            className="astenaRegForm"
                        >

                            <Row>
                                <Col span={2} style={{ textAlign: "end", paddingRight: 12 }}>
                                    <CalendarOutlined />
                                </Col>
                                <Col span={22}>
                                    <div style={{ fontWeight: "bold", marginBottom: 8 }}>Datum</div>
                                    <Form.Item
                                        //label={"Datum"}
                                        name="date"
                                        style={{}}
                                        rules={[
                                            { required: true, message: "Datum verplicht." },
                                        ]}
                                        initialValue={dayjs()}
                                    >
                                        <DatePicker locale={locale} format={"DD/MM/YYYY"} style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={2} style={{ textAlign: "end", paddingRight: 12 }}>
                                    < UserOutlined />
                                </Col>
                                <Col span={22}>
                                    <div style={{ fontWeight: "bold", marginBottom: 8 }}>Technieker</div>
                                    <Form.Item
                                        name="resourceNo"
                                        //label="Technieker"
                                        rules={[{ required: true, message: 'Technieker verplicht' }]}
                                        initialValue={user.resourceNo}
                                    >
                                        <Select
                                            showSearch
                                            loading={resources.status !== "loaded"}
                                            filterOption={(inputValue, option) =>
                                                option!.label.toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                            options={resources.status === "loaded" ? resources.payload.map(x => {
                                                return {
                                                    label: x.name + ` (${x.no})`,
                                                    value: x.no
                                                }
                                            }) : []} placeholder="Kies technieker" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={2} style={{ textAlign: "end", paddingRight: 12 }}>
                                    <ClockCircleOutlined />
                                </Col>
                                <Col span={22}>
                                    <div style={{ fontWeight: "bold", marginBottom: 8 }}>Gepresteerde uren</div>
                                    <Form.Item
                                        label={"Start"}
                                        name="start"
                                        style={{}}
                                        rules={[
                                            { required: true, message: "Start verplicht." },
                                        ]}
                                        initialValue={dayjs().format("HH:mm")}
                                    >
                                        <TimePicker clearIcon={<CloseOutlined style={{ color: "#d9d9d9", width: "auto" }} />} className={"astena-time-picker"} disableClock value={""} />
                                    </Form.Item>
                                    <Form.Item
                                        label={"Einde"}
                                        name="stop"
                                        style={{ width: "100%" }}
                                        rules={[
                                            { required: true, message: "Einde verplicht." },
                                        ]}
                                        initialValue={dayjs().format("HH:mm")}
                                    >
                                        <TimePicker clearIcon={<CloseOutlined style={{ color: "#d9d9d9", width: "auto" }} />} className={"astena-time-picker"} disableClock value={""} />
                                    </Form.Item>
                                    <Form.Item
                                        label={"Pauze"}
                                        name="break"
                                        style={{ width: "100%" }}

                                        initialValue={"00:00"}
                                    >
                                        <TimePicker clearIcon={<CloseOutlined style={{ color: "#d9d9d9", width: "auto" }} />} className={"astena-time-picker"} disableClock value={""} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={2} style={{ textAlign: "end", paddingRight: 12 }}>
                                    <CheckCircleOutlined />
                                </Col>
                                <Col span={22}>
                                    <div style={{ fontWeight: "bold", marginBottom: 8 }}>Afgewerkt</div>
                                    <Form.Item name="finished" valuePropName="checked">
                                        <Switch />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item style={{ marginBottom: 0 }}>

                                <Button
                                    size="large"
                                    type="primary"
                                    style={{ backgroundColor: "#E9492F", boxShadow: "none", width: "100%" }}
                                    htmlType="submit"
                                    loading={loading}
                                    className="astena-btn"
                                    disabled={order.status != "loaded" || order.payload.status == "Finished"}
                                >
                                    {"Toevoegen"}
                                </Button>

                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
                <Col xl={8} lg={8} md={12} sm={24}>
                    <Card bodyStyle={{ padding: 16, margin: 0 }}>
                        <PageHeaderAstena
                            style={{ padding: 0, margin: 0, marginBottom: 16 }}
                            title={
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Handtekening"}</span>
                            }

                        />
                        <Row style={{ marginBottom: 12 }}>
                            <Col span={2} style={{ textAlign: "end", paddingRight: 12 }}>
                                <UserOutlined />
                            </Col>
                            <Col span={22}>
                                <div style={{ fontWeight: "bold", marginBottom: 8 }}>Naam ondertekenaar</div>
                                <Input maxLength={100} value={signer} style={{ width: "100%" }}
                                    onChange={(e) => {
                                        setSigner(e.target.value)
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: 12 }}>
                            <Col span={2} style={{ textAlign: "end", paddingRight: 12 }}>
                                <CalendarOutlined />
                            </Col>
                            <Col span={22}>
                                <div style={{ fontWeight: "bold", marginBottom: 8 }}>Datum</div>
                                <DatePicker allowClear={false} value={signDate} locale={locale} format={"DD/MM/YYYY"} style={{ width: "100%" }}
                                    onChange={(value, dateString) => {
                                        if (value)
                                            setSignDate(value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={2} style={{ textAlign: "end", paddingRight: 12 }}>
                                <EditOutlined />
                            </Col>
                            <Col span={22}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                    <div style={{ fontWeight: "bold", marginBottom: 8 }}>Handtekening</div>
                                    <Button icon={<CloseOutlined />} onClick={() => {
                                        if (signatureRef.current) {
                                            signatureRef.current.clear();
                                        }
                                    }}>clear</Button>
                                </div>

                                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <div ref={containerRef} style={{ width: "100%", height: 250, border: "1px solid #f0f0f0", borderRadius: "0 0 8px 8px", padding: 4 }}>
                                        <SignatureCanvas
                                            canvasProps={{ width: "100%", height: 250 }}
                                            ref={signatureRef}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </div >

    );
};

export default CreateTimeRegistration;